// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b5c56844","404":"bdc8b815","787":"f397e11b"}[chunkId] + ".chunk.js";
};